export const GET_MASTER_DATA = 'GET_MASTER_DATA';
export const LOADING_DATA ='LOADING_DATA';
export const SHOW_SNACKBAR ='SHOW_SNACKBAR';
export const GET_NOTIFICATIONS ='GET_NOTIFICATIONS';
export const ADD_VAULT_DATA ='ADD_VAULT_DATA';
export const GET_VAULT_DATA ='GET_VAULT_DATA';
export const UPDATE_VAULT_DATA ='UPDATE_VAULT_DATA';
export const CALL_LOAD_MORE_DATA ='CALL_LOAD_MORE_DATA';
export const GET_CURRENT_ROUTE ='GET_CURRENT_ROUTE';
export const SET_MULTI_SELECT_LIST ='SET_MULTI_SELECT_LIST';
export const GET_MULTI_SELECT_DATA ='GET_MULTI_SELECT_DATA'
export const GET_OCCUPATIONS ='GET_OCCUPATIONS';
export const GET_VERTICAL_LIST ='GET_VERTICAL_LIST';
export const GET_PRODUCT_LIST ='GET_PRODUCT_LIST';
export const GET_IMD_RELATION_LIST ='GET_IMD_RELATION_LIST';
export const GET_CHANNEL_ZONE_LIST ='GET_CHANNEL_ZONE_LIST';
export const GET_BIRTHDAY_LIST ='GET_BIRTHDAY_LIST';
export const SET_MAP_INFO ='SET_MAP_INFO'

